/**
 * Created by slava on 24.03.17.
 */

const FinisherWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.FinisherWindow;

        this._super({
            title: Messages.get("FinisherWindow.title"),
            name: "finisherwindow",
            content: this.generateContent(),
            fireworks: true,
            button: {
                width: styles.button.width,
                height: styles.button.height,

                text: Messages.get("FinisherWindow.Button.text"),
                onPressed: function () {
                    connector.social.joinCommunityCallback();
                }
            },
            openSound: bundles.finisher_window.urls.finisher_effect
        });
    },

    generateStoreButton: function (source) {
        const image = {
            android: bundles.finisher_window.urls.android_png,
            ios: bundles.finisher_window.urls.ios_png,
            amazon: bundles.finisher_window.urls.amazon_png
        }[source];

        const url = connector.platform.getGameUrl(source);

        if (!url || !image) {
            return undefined;
        }

        const sprite = new cc.Sprite(image);
        cleverapps.UI.applyHover(sprite);
        cleverapps.UI.onClick(sprite, () => {
            connector.platform.openUrl(url);
        });

        return sprite;
    },

    generateContent: function () {
        const styles = cleverapps.styles.FinisherWindow;

        const items = [];

        items.push(this.createText(Messages.get("FinisherWindow.GroupText")));

        if (!connector.info.isNative && !connector.platform.oneOf(connector.OK, connector.OKBRIDGE, connector.VK, connector.MM, connector.INSTANT)) {
            const nativeAppButtons = ["android", "ios", "amazon"].map(this.generateStoreButton).filter((item) => item !== undefined);

            if (nativeAppButtons.length > 0) {
                items.push(this.createButtonsLayout(nativeAppButtons.slice(0, 2)));

                items.push(this.createText(Messages.get("FinisherWindow.StoreText")));
            }
            items.push(this.createText(Messages.get("FinisherWindow.AllPassedText")));
        } else {
            const button = this.generateStoreButton(connector.info.source);
            if (button) {
                items.push(button);
            }
            items.push(this.createText(Messages.get("FinisherWindow.AllAndStoreText")));
        }

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createText: function (msg) {
        const styles = cleverapps.styles.FinisherWindow;

        const text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);

        return text;
    },

    createButtonsLayout: function (buttons) {
        const styles = cleverapps.styles.FinisherWindow;

        return new cleverapps.Layout(buttons, {
            padding: styles.button.padding,
            margin: styles.button.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    listBundles: function () {
        return ["finisher_window"];
    }
});

cleverapps.styles.FinisherWindow = {
    margin: 10,

    text: {
        width: 550
    },

    button: {
        padding: {
            x: 0,
            y: 10
        },

        margin: 30,

        width: 460,
        height: 100
    }
};
